import { PrismicNextImage, PrismicNextLink } from "@prismicio/next";
import { PrismicRichText } from "@prismicio/react";
import { isFilled } from "@prismicio/client";

/**
 * @typedef {import("@prismicio/client").Content.FooterInfoSlice} FooterInfoSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<FooterInfoSlice>} FooterInfoProps
 * @type {import("react").FC<FooterInfoProps>}
 */
const FooterInfo = ({ slice }) => {
  return (
    <div
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="flex flex-col gap-4 lg:gap-6 w-full md:w-1/3"
    >
      {isFilled.image(slice.primary.logo) && (
        <div className="max-w-74 md:max-w-100 w-full h-auto">
          <PrismicNextImage
            field={{
              ...slice.primary.logo,
              alt: slice.primary.logo.alt || "Logo"
            }}
            className="w-full h-auto object-contain"
          />
        </div>
      )}

      {isFilled.richText(slice.primary.adress) && (
        <div className="text-sm">
          <PrismicRichText
            field={slice.primary.adress}
            components={{
              paragraph: ({ children }) => (
                <p className="text-sm text-graphite">{children}</p>
              ),
              hyperlink: ({ node, children }) => (
                <a
                  href={node.data.url}
                  className="text-sm text-graphite hover:underline hover:decoration-green hover:decoration-1 hover:underline-offset-4 transition-all"
                  target={node.data.target || "_self"}
                  rel={node.data.target === "_blank" ? "noopener noreferrer" : undefined}
                >
                  {children}
                </a>
              ),
            }}
          />
        </div>
      )}

      {isFilled.group(slice.primary.social_media) && (
        <div className="flex gap-4 items-center">
          {slice.primary.social_media.map((item, index) => (
            isFilled.link(item.link) && isFilled.image(item.picto) ? (
              <PrismicNextLink key={index} field={item.link} className="block">
                <PrismicNextImage
                  field={{
                    ...item.picto,
                    alt: item.picto.alt || `Réseau social ${index + 1}`
                  }}
                  className="w-6 h-6 object-contain hover:opacity-70 transition-opacity"
                />
              </PrismicNextLink>
            ) : null
          ))}
        </div>
      )}
    </div>
  );
};

export default FooterInfo;
